import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const FLEXBOX_ALIGN_MAP = {
  left: 'flex-start',
  right: 'flex-end'
};
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "vsu60c-0"
})(["display:flex;box-sizing:border-box;justify-content:", ";align-items:center;width:", ";height:100%;"], props => FLEXBOX_ALIGN_MAP[props.align], props => props.stretch ? '100%' : 'auto');

const NavigationColumn = (_ref) => {
  let {
    align = 'left',
    stretch,
    children
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["align", "stretch", "children"]);

  return /*#__PURE__*/_jsx(Container, Object.assign({
    align: align,
    stretch: stretch
  }, restProps, {
    children: children
  }));
};

NavigationColumn.propTypes = {
  stretch: T.bool,
  align: T.oneOf(['left', 'right']),
  children: T.node
};
export { NavigationColumn };